import * as Yup from 'yup';

import { CustomFormProps } from '@FormModels/shared';

export const formItems: CustomFormProps = {
    email: {
        label: '',
        validation: Yup.string().required(),
    },
};
